/**
 * D55d-uat3 — Access Requests badge poller.
 *
 * Returns TWO counts:
 *   - approverPending: number of pending requests where the current user
 *     is the CURRENT approver. Drives the approver-only sidebar entry
 *     (entry is hidden when 0).
 *   - mineOpen: number of the current user's own open (pending) requests.
 *     Drives the "My Access Requests" badge in the Profile Menu.
 *
 * Silent on error — the badges are UX niceties, not critical.
 * Polls every 60s. Stops when user is null (logged out).
 */
import { useEffect, useState } from "react";
import api from "@/lib/api";
import { useAuth } from "@/store/auth";

export function useAccessRequestsBadge(pollMs = 60000) {
  const user = useAuth((s) => s.user);
  const [approverPending, setApproverPending] = useState(0);
  const [mineOpen, setMineOpen] = useState(0);

  useEffect(() => {
    if (!user) { setApproverPending(0); setMineOpen(0); return; }
    let stopped = false;
    const tick = async () => {
      try {
        const [p, m] = await Promise.all([
          api.get("/access-requests/pending", { silent: true }),
          api.get("/access-requests/mine", { silent: true }),
        ]);
        if (stopped) return;
        setApproverPending(Number(p?.data?.total) || 0);
        const mineItems = m?.data?.items || [];
        setMineOpen(mineItems.filter((r) => r.status === "pending").length);
      } catch (_e) { /* silent */ }
    };
    tick();
    const iv = setInterval(tick, pollMs);
    return () => { stopped = true; clearInterval(iv); };
  }, [user, pollMs]);

  return { approverPending, mineOpen };
}

export default useAccessRequestsBadge;
